const categories = [
  'agricultural',
  'cars',
  'commercial',
  'construction',
  'marine',
  'motorcycles',
  'trucks',
];

enum categoriesEnum {
  'cars' = 1,
  'commercial' = 2,
  'trucks' = 3,
  'motorcycles' = 4,
  'agricultural' = 5,
  'marine' = 6,
  'off-highway' = 7,
  'construction' = 10,
}
enum categoriesOatsEnum {
  cars = 1,
  vans = 2,
  motorcycles = 3,
  trucks = 4,
  agricultural = 5,
  off_highway = 6,
  construction = 7,
}


enum categoriesInfomediaEnum {
  'cars' = 1,
  'commercial' = 2,
  'trucks' = 3,
  'motorcycles' = 4,
  'engine' = 8,
  'trimmer' = 9,
  'agricultural' = 12,
  'off-highway' = 13,
  'construction' = 14,
}


const matchCatrgories = (value: string) => {
  for (const category of categories) {
    const reg = new RegExp(category, 'i');
    if (reg.test(value)) {
      return category;
    }
  }

  return undefined;
};

const getTypeFromId = (id: number, type = 'olyslager') => {
  if (type.startsWith('olyslager')) {
    return categoriesEnum[id];
  }
  else if (type.startsWith('infomedia')) {
    if ((id === 5) || (id === 6) || (id === 7)) {
      return 'marine';
    }
    else if (id === 10 || id === 11) {
      return 'mower';
    }
    return categoriesInfomediaEnum[id];
  }
  else if (type.startsWith('oats')) {
    if (id === 8) {
      return 'marine';
    }
    return categoriesOatsEnum[id];
  }
  else if (type.startsWith('infor')){
    if (id === 15) {
      return 'bus';
    }
    return categoriesEnum[id]
  }
  else {
    return categoriesEnum[id];
  }
};

export default matchCatrgories;
export { getTypeFromId };
